module.exports = __webpack_public_path__ + "img/type3_bg1.c6f545fd.png";